import { ApiResponse, CasePermissions, BowtieSupported } from 'app/types-shared';
import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint } from 'app/area/case/endpoints';

export const api = {
  
  caseEntityId: async (caseId: number): Promise<number> => {

    return (await new RemoteData(`${endpoint.case}/${caseId}/primaryEntityId`)
      .resource<ApiResponse<number>>()
      .single() as any).data;
  },
  
  addCaseConnection: async (draftId: number, connectedCaseId: number, connectionTypeId: number, sequence: number) => {
    await new RemoteData(`${endpoint.draft}/${draftId}/connections`)
      .resource<any>()
      .filter({
        caseId: connectedCaseId,
        connectionTypeId,
        sequence
      })
      .create({});
  },

  casePermissions: async (ids: number[]): Promise<CasePermissions[]> => {

    const response = await new RemoteData(endpoint.casePermissions).resource<ApiResponse<CasePermissions[]>>()
      .filter({ caseId: ids })
      .single();

    return response.data;
  },

  bowtieSupported: async (ids: number[]): Promise<BowtieSupported[]> => {

    const response = await new RemoteData(endpoint.bowtieSupported).resource<ApiResponse<BowtieSupported[]>>()
      .filter({ caseId: ids })
      .single();

      return response.data;
    }
};
